import { Link } from 'react-router-dom';

const shopLinks = [
  { label: 'T-Shirts', path: '/t-shirts' },
  { label: 'Magic Dresses', path: '/magic-dresses' },
  { label: 'Jackets', path: '/jackets' },
  { label: 'Scarves', path: '/scarves' },
  { label: 'Metal Drums', path: '/metal-drums' },
  { label: 'Magic Dress How-To\'s', path: '/magic-dress-howtos' },
];

const infoLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact Us', path: '/contact' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#1E4F4F' }} className="text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="flex flex-col gap-4 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/fbf245d3ea2c09ae3edd46f7fa5d3b47.webp"
              alt="Earth Wisdom™ Music and Clothing"
              className="w-auto object-contain"
              style={{ height: '110px' }}
            />
            <p style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8', lineHeight: 1.7 }} className="text-sm">
              Outrageously gorgeous goddess clothing, artist-designed tees, and healing music — since 1981.
            </p>
            <p style={{ fontFamily: '"Dancing Script", cursive', color: '#E8B96A', fontSize: '1.05rem' }}>
              Trusted since 1981 ✦ Michigan
            </p>
          </div>

          {/* Shop Links */}
          <div>
            <h4 style={{ fontFamily: '"Playfair Display", serif', color: '#E8B96A' }} className="text-base font-bold mb-4">Shop</h4>
            <ul className="flex flex-col gap-2.5">
              {shopLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }}
                    className="text-sm hover:text-[#E8B96A] transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info Links */}
          <div>
            <h4 style={{ fontFamily: '"Playfair Display", serif', color: '#E8B96A' }} className="text-base font-bold mb-4">Info</h4>
            <ul className="flex flex-col gap-2.5">
              {infoLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }}
                    className="text-sm hover:text-[#E8B96A] transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: '"Playfair Display", serif', color: '#E8B96A' }} className="text-base font-bold mb-4">Get in Touch</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a href="tel:7346468620" style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }}
                  className="flex items-center gap-2.5 text-sm hover:text-[#E8B96A] transition-colors duration-200 whitespace-nowrap">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#2C6B6B] flex-shrink-0">
                    <i className="ri-phone-line text-xs" style={{ color: '#E8B96A' }}></i>
                  </span>
                  734.646.8620
                </a>
              </li>
              <li>
                <a href="mailto:earthwisdom80@gmail.com" style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }}
                  className="flex items-center gap-2.5 text-sm hover:text-[#E8B96A] transition-colors duration-200">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#2C6B6B] flex-shrink-0">
                    <i className="ri-mail-line text-xs" style={{ color: '#E8B96A' }}></i>
                  </span>
                  earthwisdom80@gmail.com
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/EarthWisdomMusicandClothing" target="_blank" rel="nofollow noopener noreferrer"
                  style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }}
                  className="flex items-center gap-2.5 text-sm hover:text-[#E8B96A] transition-colors duration-200 whitespace-nowrap">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#2C6B6B] flex-shrink-0">
                    <i className="ri-facebook-fill text-xs" style={{ color: '#E8B96A' }}></i>
                  </span>
                  EarthWisdomMusicandClothing
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#2C6B6B] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p style={{ fontFamily: '"Lato", sans-serif', color: '#6A9898', fontSize: '0.75rem' }}>
            &copy; {new Date().getFullYear()} Earth Wisdom™ Music and Clothing. All rights reserved. Artist-original designs — copyrighted by individual artists.
          </p>
          <a
            href="https://kalamazoowebsitedesign.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{ fontFamily: '"Lato", sans-serif', color: '#6A9898', fontSize: '0.75rem' }}
            className="hover:text-[#A0C8C8] transition-colors duration-200 whitespace-nowrap"
          >
            Powered by Kalamazoo Website Design
          </a>
        </div>
      </div>
    </footer>
  );
}
